export default Object.freeze({
  CareCenter: 246,
  PrivateSchool: 248,
  HeadStart: 250,
  Home: 251,
});
